export default __webpack_public_path__ + "static/image-mobile-751459a28d90d343bd24c99c3778df8c.webp";